import React from "react";
import { ProgressSpinner } from "@bbnpm/bb-ui-framework";
import { StyledContent } from "./index.styles";

export declare namespace Loading {
  export interface Props {
    label?: string;
  }
}

export const Loading: React.FC<Loading.Props> = ({ label = "Loading..." }) => (
  <StyledContent>
    <div className="text-wrapper">
      <ProgressSpinner size="large" label={label} />
    </div>
  </StyledContent>
);
